import { pickBy, isEqual } from 'lodash-es';

/**
 * Return activity list paginated.
 *
 * @param state
 * @returns {T[]}
 */
export const activityPaginated = (state) => {
    const _activity = state.activity.items || [];
    const _page = state.activity.page;
    const _limit = state.activity.limit;

    return _activity.slice(_page * _limit - _limit, _page * _limit);
};

/**
 * Get the max page count of the activity list.
 *
 * @param state
 * @returns {number}
 */
export const activityMaxPages = (state) => {
    const _activity = state.activity.items || [];
    const _limit = state.activity.limit;

    return Math.ceil(_activity.length / _limit);
};

/**
 * Get a list of the days activated for notification.
 *
 * @param state
 * @returns {{}|*}
 */
export const activeWeekdays = (state) => {
    const _weekdays = (state.notifications.item) ? state.notifications.item.days : [];
    return pickBy(_weekdays, (day) => {
        return day;
    });
};

/**
 * Check if the user object has changed.
 *
 * @param state
 * @returns {boolean}
 */
export const userHasChanged = (state) => {
    const _user = state.user.user || {};
    const _originalUser = state.user.originalUser || {};
    return !isEqual(_user, _originalUser);
};



// WEBPACK FOOTER //
// ./src/store/modules/account/getters.js